<central-login-header [platform]="currentPlatform"></central-login-header>
<div class="content">
    <div class="alert alert-info" *ngIf="currentPlatform">
        {{ 'central-login.create.account.mail.verified' | translate : { 'name' : currentPlatform?.club?.name } }} <a class="u-cursor--pointer" (click)="goToLogin()">{{ 'central-login.create.account.mail.verified.here' | translate }}</a>.
    </div>
    <div class="alert alert-info" *ngIf="!currentPlatform">
        {{ 'central-login.create.account.mail.verified.without.platform' | translate }} <a class="u-cursor--pointer" (click)="goToLogin()">{{ 'central-login.create.account.mail.verified.here' | translate }}</a>.
    </div>
</div>
<central-login-footer></central-login-footer>
<central-login-background-slider [platform]="currentPlatform" ></central-login-background-slider>
